import { useMutation, useQueryClient } from "@tanstack/react-query";

import { kpiService } from "../../../services/kpiService";
import type { Kpi } from "../../../types";

export const useCreateKpi = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (input: Pick<Kpi, "name" | "description" | "thresholds">) =>
      kpiService.create(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["kpis"] });
      qc.invalidateQueries({ queryKey: ["service-templates"] });
    },
  });
};
